import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useFormik } from "formik";
import { useContext, useEffect, useState } from "react";
import { ContextOperation } from "../../context/OperationContext";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import useSnackbar from "../../hooks/useSnackbar";
import MonySymbolsComponets from "../common/MonySymbolsComponents";
import { nameof } from "../common/ObjectUtils";
import DamageService from "./service/damage.action";
import { DamageTypes } from "./Types";
import "./damagePrice.css";
interface Props {
  open: boolean;
  onClose: () => void;
  dangerPriveList?: DamageTypes.Damage;
  updateDatasourceDamage: () => void;
  onReset: () => void;
  formikValues: DamageTypes.FilterDamage;
  // updateDatasourceAcriss: () => void;
}

const EditDamagePriceList = (props: Props) => {
  const snackbar = useSnackbar();
  const { setLoading } = useContext(ContextOperation);
  const t = useOperationTranslation();

  const paintExtraTime = [
    {
      value: true,
      label: t("internOptionSelectName.true"),
    },
    {
      value: false,
      label: t("internOptionSelectName.false"),
    },
  ];

  const handleSubmit = (data: DamageTypes.Edit) => {
    if (data.substitionPrice) {
      data.substitionPrice = data.substitionPrice * 100;
    }
    if (data.lightPrice) {
      data.lightPrice = data.lightPrice * 100;
    }
    if (data.mediumPrice) {
      data.mediumPrice = data.mediumPrice * 100;
    }
    if (data.heavyPrice) {
      data.heavyPrice = data.heavyPrice * 100;
    }

    console.log(JSON.stringify(data));

    setLoading(true);
    DamageService.put.edit(data).then(
      () => {
        onClose();
        setLoading(false);
        if (props.formikValues) {
          props.onReset();
        }
        props.updateDatasourceDamage();
        snackbar.show("success", t("dangerPrice.messages.editMessages"));
      },
      (error: any) => {
        onClose();
        setLoading(false);
        if (error.response.status == 404) {
          snackbar.show("error", t("dangerPrice.messages.edit404Error"));
        } else {
          snackbar.show("error", t("dangerPrice.messages.edit500Error"));
        }
      }
    );
  };

  const formik = useFormik<DamageTypes.Edit>({
    initialValues: {},

    onSubmit: handleSubmit,
  });
  useEffect(() => {
    formik.resetForm({
      values: {
        id: props.dangerPriveList?.id,
        substitionPrice: props.dangerPriveList?.substitionPrice,
        lightPrice: props.dangerPriveList?.lightPrice,
        mediumPrice: props.dangerPriveList?.mediumPrice,
        heavyPrice: props.dangerPriveList?.heavyPrice,
        paintExtraTime: props.dangerPriveList?.paintExtraTime,
        winityCodeVehicle: props.dangerPriveList?.winityCodeVehicle,
        winityCodeIndustrial: props.dangerPriveList?.winityCodeIndustrial,
        figureCode: props.dangerPriveList?.figureCode,
      },
    });
  }, [props.dangerPriveList, props.open]);
  const onClose = () => {
    props.onClose();
    formik.resetForm();
  };

  console.log(formik.values.paintExtraTime, "formik.values.paintExtraTime");

  return (
    <Mui.Dialog open={props.open} onClose={onClose} fullWidth maxWidth="lg">
      <Mui.DialogTitle>
        <Mui.Grid container alignItems="center">
          <Mui.Grid item xs="auto">
            <Mui.Typography variant="h6">
              {t("dangerPrice.dialogs.editAcriss.title")}
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid item xs="auto" marginLeft="auto">
            <Mui.IconButton onClick={onClose}>
              <MuiIcons.Close />
            </Mui.IconButton>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogTitle>
      <Mui.DialogContent>
        <form
          id="form-create-equipment-kit-association"
          onSubmit={formik.handleSubmit}
        >
          <Mui.Grid container spacing="16px" height="100px">
            <Mui.Grid item md={3} xs={12}>
              <Mui.TextField
                label={t("dangerPrice.fields.substitution")}
                name={nameof<DamageTypes.Edit>("substitionPrice")}
                fullWidth
                onChange={formik.handleChange}
                value={formik.values.substitionPrice || ""}
                InputProps={{
                  startAdornment: (
                    <Mui.InputAdornment position="start">
                      <MonySymbolsComponets
                        symbols={props.dangerPriveList?.currency}
                      />
                    </Mui.InputAdornment>
                  ),
                }}
              />
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <Mui.TextField
                label={t("dangerPrice.fields.damage")}
                name={nameof<DamageTypes.Edit>("lightPrice")}
                fullWidth
                value={formik.values.lightPrice || ""}
                onChange={formik.handleChange}
                InputProps={{
                  startAdornment: (
                    <Mui.InputAdornment position="start">
                      <MonySymbolsComponets
                        symbols={props.dangerPriveList?.currency}
                      />
                    </Mui.InputAdornment>
                  ),
                }}
              />
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <Mui.Grid item>
                <Mui.TextField
                  label={t("dangerPrice.fields.medium")}
                  name={nameof<DamageTypes.Edit>("mediumPrice")}
                  fullWidth
                  value={formik.values.mediumPrice || ""}
                  onChange={formik.handleChange}
                  InputProps={{
                    startAdornment: (
                      <Mui.InputAdornment position="start">
                        <MonySymbolsComponets
                          symbols={props.dangerPriveList?.currency}
                        />
                      </Mui.InputAdornment>
                    ),
                  }}
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <Mui.Grid item>
                <Mui.TextField
                  label={t("dangerPrice.fields.heavy")}
                  name={nameof<DamageTypes.Edit>("heavyPrice")}
                  fullWidth
                  value={formik.values.heavyPrice || ""}
                  onChange={formik.handleChange}
                  InputProps={{
                    startAdornment: (
                      <Mui.InputAdornment position="start">
                        <MonySymbolsComponets
                          symbols={props.dangerPriveList?.currency}
                        />
                      </Mui.InputAdornment>
                    ),
                  }}
                />
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container spacing="16px" height="100px">
            <Mui.Grid item md={3} xs={12}>
              <Mui.FormControl variant="standard" fullWidth>
                <Mui.InputLabel>{t("dangerPrice.fields.paint")}</Mui.InputLabel>
                <Mui.Select
                  label={t("dangerPrice.fields.paint")}
                  fullWidth
                  name={nameof<DamageTypes.Edit>("paintExtraTime")}
                  value={
                    formik.values.paintExtraTime !== undefined
                      ? formik.values.paintExtraTime
                      : ""
                  }
                  onChange={formik.handleChange}
                >
                  {paintExtraTime.map((el: any, index: number) => (
                    <Mui.MenuItem key={index} value={el.value}>
                      {el.label}
                    </Mui.MenuItem>
                  ))}
                </Mui.Select>
              </Mui.FormControl>
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <Mui.TextField
                label={t("dangerPrice.fields.winity")}
                name={nameof<DamageTypes.Edit>("winityCodeVehicle")}
                fullWidth
                value={formik.values.winityCodeVehicle || ""}
                onChange={formik.handleChange}
              />
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <Mui.Grid item>
                <Mui.TextField
                  label={t("dangerPrice.fields.industrial")}
                  name={nameof<DamageTypes.Edit>("winityCodeIndustrial")}
                  fullWidth
                  value={formik.values.winityCodeIndustrial || ""}
                  onChange={formik.handleChange}
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <Mui.Grid item>
                <Mui.TextField
                  label={t("dangerPrice.fields.figure")}
                  name={nameof<DamageTypes.Edit>("figureCode")}
                  fullWidth
                  value={formik.values.figureCode || ""}
                  onChange={formik.handleChange}
                />
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Grid>
        </form>
      </Mui.DialogContent>
      <Mui.DialogActions>
        <Mui.Grid container justifyContent="end" spacing="16px">
          <Mui.Grid item xs="auto" height="48px">
            <Mui.Button
              variant="outlined"
              size="medium"
              sx={{ maxWidth: "111px", minWidth: "111px", fontWeight: 700 }}
              onClick={onClose}
            >
              {t(
                "vehicleEquipmentAssociation.dialogs.editAcriss.actions.cancel"
              )}
            </Mui.Button>
          </Mui.Grid>
          <Mui.Grid item xs="auto">
            <Mui.Button
              type="submit"
              size="medium"
              sx={{ maxWidth: "111px", minWidth: "111px", fontWeight: 700 }}
              onClick={formik.submitForm}
            >
              {t("vehicleEquipmentAssociation.dialogs.editAcriss.actions.save")}
            </Mui.Button>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogActions>
    </Mui.Dialog>
  );
};

export default EditDamagePriceList;
